import {FC} from "react";
import {DisableButtonWrapper} from "features/devices/ui/components/styles.ts";

type Props = {
    id: string,
    openModal: (id: string) => void,
};

export const DisableButton: FC<Props> = ({ id, openModal }) => {
    return (
      <>
          <DisableButtonWrapper
            onClick={() => openModal(id)}
          >
              <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"  width="20.000000" height="20.000000" fill="none">
                  <rect id="24 / Special / Unplug" width="20.000000" height="20.000000" x="0.000000" y="0.000000" />
                  <path id="Union" d="M16.3005 4.58334L17.5252 3.35857L16.6414 2.47478L15.4167 3.69955L15.1263 3.40923C13.906 2.18884 11.9274 2.18884 10.707 3.40923L9.14144 4.97478C8.89742 5.21884 8.89742 5.6145 9.14144 5.85857L14.1414 10.8586C14.3855 11.1026 14.7812 11.1026 15.0252 10.8586L16.5908 9.29301C17.8112 8.07263 17.8112 6.09405 16.5908 4.87366L16.3005 4.58334ZM11.5908 4.29301C12.323 3.56078 13.5103 3.56078 14.2426 4.29301L15.707 5.75745C16.4392 6.48968 16.4392 7.67699 15.707 8.40923L14.5833 9.53288L10.4671 5.41667L11.5908 4.29301ZM9.60856 8.77523L7.55046 10.8333L9.16667 12.4495L11.2248 10.3914L12.1086 11.2752L10.0505 13.3333L10.8586 14.1414C11.1026 14.3855 11.1026 14.7812 10.8586 15.0252L9.29301 16.5908C8.07262 17.8112 6.09404 17.8112 4.87366 16.5908L4.58333 16.3005L2.94189 17.9419L2.05811 17.0581L3.69954 15.4167L3.40922 15.1263C2.18883 13.906 2.18882 11.9274 3.40922 10.707L4.97477 9.14144C5.21884 8.89743 5.6145 8.89743 5.85856 9.14144L6.66667 9.94955L8.72477 7.89144L9.60856 8.77523ZM4.29301 11.5908C3.56077 12.323 3.56077 13.5103 4.29301 14.2426L5.75745 15.707C6.48968 16.4392 7.67699 16.4392 8.40922 15.707L9.53288 14.5833L5.41667 10.4671L4.29301 11.5908Z" fill="rgb(255,38,38)" fill-rule="evenodd" />
              </svg>
              Отключить
          </DisableButtonWrapper>
      </>
    )
};
